const getData = R.prop('data');

export const fetchSchema = ({ lang = 'en', channel }) => {
    if (!channel) {
        return;
    }

    const url = `/channel/${channel}/schema?language=${lang}`;
    console.log({ url, lang, channel });

    return axios.get(url).then(getData);
};

export const fetchChannels = () => {
    return axios.get(`/documentation/channel`).then(getData);
};
